import type { ReactNode } from "react";
import { useAuth } from "../auth.js";
import { I18nProvider } from "./index.js";

/**
 * CT-RM-30: the staff app's language — the signed-in user's preference (My
 * preferences → Language). Public pages nest their own provider keyed to the
 * language the API served, which wins inside them.
 */
export function StaffI18n({ children }: { children: ReactNode }) {
  const { preferences } = useAuth();
  return <I18nProvider language={preferences.language ?? "en"}>{children}</I18nProvider>;
}
